import './DurationPicker.css';
import { __ } from '@wordpress/i18n';
import { useEffect } from 'react';
import { formatDuration } from '../utils/date-time';
import { useService, useSelectedDuration } from '../hooks/useBookingComputed';
import { useBookingStore } from '../store/useBookingStore';

export function DurationPicker() {
	const { data: service } = useService();
	const selectedDuration = useSelectedDuration();
	const setSelectedDuration = useBookingStore(
		(state) => state.setSelectedDuration
	);
	const isFlexibleDuration = Boolean(service?.flexibleDuration);
	const blockSize = service?.blockSize ?? 0;
	const minDuration = service?.minDuration ?? blockSize;
	const maxDuration = service?.maxDuration ?? blockSize;

	useEffect(() => {
		// Ensure initial pricing/time range honors minimum duration.
		if (!isFlexibleDuration || minDuration <= 0 || selectedDuration > 0) {
			return;
		}

		if (selectedDuration <= 0) {
			setSelectedDuration(minDuration);
		}
	}, [
		isFlexibleDuration,
		selectedDuration,
		minDuration,
		setSelectedDuration,
	]);

	if (!isFlexibleDuration) {
		return null;
	}

	// Generate duration options in block size increments
	const options = [];
	for (let d = minDuration; d <= maxDuration; d += blockSize) {
		options.push({
			value: d,
			label: formatDuration(d),
		});
	}

	return (
		<div className="gpb-booking-time-picker__duration-picker">
			<label htmlFor="gpb-duration-select">
				{__('Duration:', 'gp-bookings')}
			</label>
			<select
				id="gpb-duration-select"
				value={selectedDuration}
				onChange={(e) =>
					setSelectedDuration(parseInt(e.target.value, 10))
				}
			>
				{options.map(({ value, label }) => (
					<option key={value} value={value}>
						{label}
					</option>
				))}
			</select>
		</div>
	);
}
